const DEFAULT_FORM_DATA = {
	formActive: null,
	isFormDirty: false,
};

export {DEFAULT_FORM_DATA};
